import { GridColumn } from 'types/grid';
import { ModalListData } from 'types/modal';
import { ListType } from 'types/selectbox';

// 교신프로필 그리드 리스트
export const manageGridColumns: GridColumn[] = [
  { title: 'Name', key: 'name', width: 220, showOnMobile: true},
  { title: 'Ground Station', key: 'groundStationName', width: 200, showOnMobile: false},
  { title: 'City', key: 'city', width: 180, showOnMobile: false },
  { title: 'Minimum Contact Duration', key: 'minimumContactDuration', width: 240, showOnMobile: false}, 
  { title: 'Minimum elevation in degrees', key: 'minimumDegrees', width: 250, showOnMobile: false},    
  { title: 'Registered At', key: 'registeredAt', width: 180 , showOnMobile: false },                     
  { title: '', key: 'viewDetails', showOnMobile: true }
];

// 교신프로필 상세보기 그리드 
export const manageModalList: ModalListData[] = [
  { title: 'Name', key: 'name' },
  { title: 'Ground Staion', key: 'groundStationName' },
  { title: 'City', key: 'city' },
  { title: 'Location', key: 'location' },
  { title: 'Minimum Contact Duration', key: 'minContactDuration' },
  { title: 'Minimum elevation in degrees', key: 'minElevationDegrees' },
  { title: 'Registered At', key: 'registeredAt' },
];

export const registerContactProfileList: ModalListData[] = [
  { title: 'Ground Staion', key: 'groundstationId' },  
  { title: 'Ground Staion', key: 'groundstationName' },
  { title: 'Name', key: 'name' }, 
  { title: 'Minimum Contact Duration', key: 'minimumContactDuration' },
  { title: 'Minimum elevation in degrees', key: 'minimumDegrees' },
];

export const registerPolarizationList: ListType[] = [
  { value: 1, label: 'RHCP' },
  { value: 2, label: 'LHCP' },
  { value: 3, label: 'BOTH' }
];

export const registerDirectionList: ListType[] = [
  {value:1 , label: 'Uplink'},
  {value:2 , label: 'Downlink'},
];
export const registerBandList: ListType[] = [
  {value:1 , label: 'S-Band'},
  {value:2 , label: 'X-Band'},
];

